import { useTranslation } from 'react-i18next'
import { format, parseISO } from 'date-fns'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { NotificationInline } from '../../../Notification'
import Text from '../../../Text'
import {
  QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD,
  QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD_FAILED,
} from '../AppointmentFollowUpModal.constants'
import {
  getIsAppointmentFollowUpDayFull,
  getIsAppointmentFollowUpDayLoadUnavailable,
} from '../AppointmentFollowUpModal.utils'

function AppointmentFollowUpModalDayLoad({ advisory }) {
  const { t } = useTranslation()

  return getIsAppointmentFollowUpDayFull(advisory) ? (
    <NotificationInline
      qaName={QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD}
      text={t('Appointment.CouplingCapWarningKey', {
        date: format(parseISO(advisory.date), DATE_SHORT_FORMAT),
        limit: advisory.limit,
        used: advisory.follow_up_count,
      })}
      type={NOTIFICATION_TYPE.warning}
    />
  ) : getIsAppointmentFollowUpDayLoadUnavailable(advisory) ? (
    <Text isSecondary qaName={QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD_FAILED}>
      {t('Appointment.CouplingLoadFailedKey')}
    </Text>
  ) : null
}

export default AppointmentFollowUpModalDayLoad
